import createStudent from './create/index';

export default {
  modules: {
    'create-student': createStudent,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/student/index.js